module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_ohiolink_f3c8aed.ico";